import { useVendastaSSO } from 'features/vendasta/login/useVendastaSSO'

export const useThirdPartyAuthentication = () => {
  useVendastaSSO()
}
